enum DigitalProductTypes {
  GuaranteePlus = 'guarantee-plus',
  RemoteAccess = 'remote-access-smart-lock',
  RemoteAccessSmartLockGo = 'remote-access-smart-lock-go',
  RemoteAccessSmartDoor = 'remote-access-smart-door',
  SmartHosting = 'smart-hosting',
  NukiPremium = 'nuki-premium',
}

export default DigitalProductTypes;
